<template>
  <div class="p-4 min-h-screen flex flex-col justify-center">
    <logos />

    <template v-if="offline">
      <OfflineComplete />
    </template>
    <template v-else>
      <OnlineComplete :survey="survey" />
    </template>

    <button
      type="button"
      class="mt-10 flex justify-between items-center w-full sm:w-72 md:w-80 text-left border-4 border-white p-3 my-2 text-2xl font-bold font-display leading-tight focus:outline-none focus:border-orange-700"
      @click="close"
    >
      <span>Close</span>
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 22 22"
          class="w-8 h-8"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            d="M1 1h20v20H1z"
          />
          <path
            fill="currentColor"
            d="M11.8 16.5c-.3.3-.7.3-.9 0l-5.3-5.3c-.3-.3-.3-.7 0-.9L10.9 5c.3-.3.7-.3.9 0l.6.6c.3.3.3.7 0 .9L9.1 9.7H17c.4 0 .7.3.7.7v.9c0 .4-.3.7-.7.7H9.1l3.3 3.1c.3.3.3.7 0 .9l-.6.5z"
          />
        </svg>
      </span>
    </button>
  </div>
</template>

<script>
import Logos from '@/components/Logos'
import OfflineComplete from '@/components/OfflineComplete'
import OnlineComplete from '@/components/OnlineComplete'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('survey')

export default {
  components: {
    Logos,
    OfflineComplete,
    OnlineComplete
  },
  data () {
    return {
      navigatorOnLine: true
    }
  },
  computed: {
    ...mapGetters([
      'survey'
    ]),
    offline () {
      return !this.navigatorOnLine
    }
  },
  created () {
    this.navigatorOnLine = navigator.onLine
    // window.addEventListener('offline', (e) => { this.navigatorOnLine = false })
    // window.addEventListener('online', (e) => { this.navigatorOnLine = true })
  },
  methods: {
    close () {
      const defaultSurveysHashes = [
        process.env.VUE_APP_SURVEY_1_HASH,
        process.env.VUE_APP_SURVEY_2_HASH,
        process.env.VUE_APP_SURVEY_3_HASH
      ]

      if (defaultSurveysHashes.indexOf(this.survey.hash) !== -1) {
        this.$router.push({ name: 'home' })
      } else {
        this.$router.push({ name: 'survey_hash', params: { survey_hash: this.survey.hash } })
      }
    }
  }
}
</script>
